import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectContextCore } from '@store/context/context.selector';
import { IContextCore } from '@store/context/context.state';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Pipe({
  name: 'Currency',
})
export class CurrencyPipe implements PipeTransform, OnDestroy {
  constructor(private store$: Store<IContextCore>) {}
  private unSubscribe$ = new Subject<void>();
  private country: string;
  public transform(item, currencyCode?: string) {
    this.store$
      .pipe(select(selectContextCore), takeUntil(this.unSubscribe$))
      .subscribe((context) => {
        this.country = context.site.toUpperCase();
      });
    const separator: string = this.country === 'MEX' ? ',' : '.';
    if (item === '-') {
      return item;
    }
    const currency: string = String(Math.ceil(item)).split('').reverse().join('');
    const len: number = currency.length;
    let cu = '';
    for (let i = 0; i < len; i++) {
      if (i !== 0 && !(i % 3)) {
        cu += separator;
      }
      cu += currency[i];
    }
    const retValue = cu.split('').reverse().join('');
    return currencyCode ? `${currencyCode + ' ' + retValue}` : retValue;
  }

  public ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.unsubscribe();
  }
}
